export default __webpack_public_path__ + "static/media/NavMapIcons-10.f06babc3.png";